import { render, staticRenderFns } from "./FieldPaddingVideo.vue?vue&type=template&id=e704d75e&"
import script from "./FieldPaddingVideo.vue?vue&type=script&lang=ts&"
export * from "./FieldPaddingVideo.vue?vue&type=script&lang=ts&"
import style0 from "./FieldPaddingVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports